/*
 * Roles del aplicativo 
 */
export enum Role {
    Ejecutor   = 'role_ejecutor',
    Supervisor = 'role_supervisor',
    Prevencion = 'role_prevencion',
    Auditoria  = 'role_auditoria',
    Administrador = 'role_administrador'
}
/*
 * Pagina inicial por rol despues de login
 */
export enum RoleInitPage {    
    Ejecutor   = "busquedaEjecutor",
    Supervisor = "checkSupervisor",
    Prevencion = "busquedaPrevencion",
    Auditoria  = "cifrasControl",
    Administrador = "Administracion"
}
/*
 * Paginas del aplicativo
 */
export enum Pages {
  path_pagenotfound  = "pageNotFound",

  path_bitacotamovim = "bitacoraMovimien",
  path_cifrascontrol = "cifrasControl",
  path_binmanager    = "binmanager",
  path_binesAbcAlta      = "binesAbc",
  path_binesAbc      = "binesAbc/:grupo",
  path_administracion   = "Administracion",
  path_configuracion= "Configuracion",
  path_busquedasejec = "busquedaEjecutor",
  path_busquedassupe = "busquedaSupervisor",  
  path_checksupe = "checkSupervisor",
  path_busquedasaudi = "busquedaAuditoria",
  path_busquedasprev = "busquedaPrevencion",
  path_detalle_bin = "detalleBin/:idBin/:check/:rechazado/:grupo",
  path_detalle_bin_prev = "detalleBinPrev/:idBin/:check/:grupo",
  path_binesAbc_edit      = "binesAbc/:idBin/:grupo",
  path_detalle_bitacora = "detalleBitacora/:idBitacora",
  path_alertas = "alertas",
  path_detalle_alerta = "alertas/:idBin/:check",
  path_movimientos_automaticos = "movimientosAutomaticos"
}

/*
 * Modelo de usuario autentificado
 */
 export class User {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    role: Role;
    token?: string;
    idEsquema: string;
    esquema: string;
}